import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import {
  removeInvitationsPopupMembersSelector
} from './selectors'
import {
  closeRemoveInvitationsPopup,
  removeInvitations
} from './slice'

export const RemovePopup = () => {
  const dispatch = useDispatch()
  const onClose = () => dispatch(closeRemoveInvitationsPopup())
  const onConfirm = () => dispatch(removeInvitations())

  const members = useSelector(removeInvitationsPopupMembersSelector)

  const title = members.length > 1
    ? I18n.t('publisher.organization.invitation.multiple_cancel_confirmation', { count: members.length })
    : I18n.t('publisher.organization.invitation.cancel_confirmation', { email: members[0].email })

  return (
    <SimplePopup
      title={title}
      cancelLabel={I18n.t('publisher.action.cancel')}
      confirmLabel={I18n.t('publisher.action.yes')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  )
}
